import React, { useEffect, useState } from "react"
import {
    Select,
    SelectItem,
    Spinner,
} from "@nextui-org/react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { apiRoute } from "../constants/enum.js"
import { setAcYearData, setCompCode, setCompInfo, setYearId } from "../state/companySlice.jsx"
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks.jsx"
import { isMobile } from "react-device-detect"
import LoadingCard from "./LoadingCard.jsx"


export default function AcYearSelection() {
    const dispatch = useDispatch()
    const { compCode, yearId, objAcYear } = useSelector((state) => state.company)
    const [compAcYearData, setCompAcYearData] = useState([])

    const [selYearId, setSelYearId] = useState(yearId);
    const [isReload, setIsReload] = useState(false);

    const {
        isLoading,
        data: acyearData = [],
        mutate: funFilterYear
    } = usePost({
        url: apiRoute.companyAcYear,
        queryKey: "CompanyAcyear"
    })

    const funFilterYearId = (value) => {
        if (value != "" && value != "0") {
            funSetYearId({
                data: {
                    ac_year: value,
                    comp_code: compCode
                }
            })

        }
    }
    useEffect(() => {
        if (selYearId == "" && acyearData && acyearData.length > 0) {
            setSelYearId(acyearData[0].year_id)
            funFilterYearId(acyearData[0].year_id)
            setAcYearData(acyearData)

        }
        // if (acyearData && acyearData.length > 1)
        //     console.log(acyearData[acyearData.length - 1].acyear)
    }, [acyearData])

    useEffect(() => {
        funFilterYear({
            data: {
                compcode: compCode.join(",")
            }
        })
    }, [compCode])

    const onSuccessSetYearId = (data) => {
        dispatch(setCompInfo({
            yearId: data[0]?.YEAR_ID, startDate: data[0]?.SDATE, endDate: data[0]?.EDATE, state: data[0]?.STATE, groupCode: data[0].CGCODE
        }))
        if (isReload) {
            const timer = setTimeout(() => {
                window.location.reload();
            }, 1500); // 30,000 milliseconds = 30 seconds
        }

    }

    const {
        isPending: isPendingAcyear,
        isError: isErrorAcyear,
        data: setYearData = [],
        mutate: funSetYearId
    } = usePost({
        url: apiRoute.setAcYearId,
        queryKey: "SetCompanyAcYearId",
        onSuccessTasks: onSuccessSetYearId

    })


    const onAcYearChange = (e) => {
        if (acyearData.length > 1) {
            setIsReload(true)
            const { value } = e.target
            setSelYearId(value)
            funFilterYearId(value)
        }
    }


    return (
        <>
            {isReload ? <div className="bg-white px-5 rounded-lg"><Spinner className="text-white" label="loading" size="sm" color="danger" ></Spinner></div> : ""}

            <Select
                size="sm"
                color={isMobile ? "danger" : "primary"}
                variant={"underlined"}
                radius="none"
                selectionMode="single"
                placeholder="---Year--"
                className={`${isMobile ? "w-full" : "max-w-32"} text-center `}
                isLoading={isLoading}
                isVirtualized
                isDisabled={compCode && compCode.length > 0 ? false : true}
                classNames={{
                    value: "font-semibold text-center  ", base: `
                ${isMobile ? "bg-gradient-to-tl from-amber-300 to-amber-200 " : "bg-gradient-to-tl from-sky-100 to-gray-50 "}`
                }}
                defaultSelectedKey={selYearId}
                items={
                    acyearData ? acyearData : []
                }
                onChange={onAcYearChange}
                selectedKeys={[String(selYearId)]}
            >
                {(item) => (
                    <SelectItem
                        key={item.year_id} >
                        {String(item.acyear)}
                    </SelectItem>
                )}

            </Select>

        </>
    )
}
